import { jsx as f } from "react/jsx-runtime";
import { useState as m, useEffect as p, useCallback as v, useMemo as x } from "react";
import { Provider as d } from "./context.js";
const k = ({ children: u, value: t = "", name: r, onChange: e }) => {
  const [n, a] = m(t);
  p(() => {
    a(t);
  }, [t]);
  const c = v(
    (o) => {
      o.persist();
      const {
        currentTarget: { value: i, checked: s }
      } = o;
      s && (a(i), typeof e == "function" && e(o, i));
    },
    [e]
  ), l = x(
    () => ({
      onChange: c,
      value: n,
      name: r
    }),
    [c, r, n]
  );
  return /* @__PURE__ */ f(d, { value: l, children: u });
};
k.displayName = "RadioContext";
export {
  k as RadioContext
};
//# sourceMappingURL=RadioContext.js.map
